<template>
    <div
        v-if="appParams && appParams.staticTranslations"
        :id="'itb-other-products-' + $route.params.productAlias"
    >
        <hero-cards
            :cards="heroCards"
            :class="{
                'pb-0': $route.params.productAlias == 'epdm-furniture',
            }"
        ></hero-cards>

        <section
            v-if="$route.params.productAlias == 'water-fountains'"
            id="itb-other-products-water-fountains-options"
        >
            <div class="container">
                <div class="row">
                    <div
                        class="col-12"
                        v-lazy-container="{ selector: '.itb-lazy' }"
                    >
                        <img
                            :data-src="'/images/articles/other-products-water-fountains-5.webp'"
                            alt="Water pump"
                            class="itb-lazy"
                        />
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-md-6 itb-left-box">
                        <div class="itb-middle-text itb-bg-blue">
                            <h2 class="itb-other-products-water-fountains-options-title">
                                {{
                                    appParams.staticTranslations[
                                        "other_products_water_fountains.options_title_left"
                                    ]
                                }}
                            </h2>
                            <p class="m-0" style="font-size: 1.25rem">
                                {{
                                    appParams.staticTranslations[
                                        "other_products_water_fountains.options_text_left_cleanvar_01"
                                    ]
                                }}
                            </p>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 itb-right-box">
                        <div class="itb-middle-text itb-bg-orange">
                            <h2 class="itb-other-products-water-fountains-options-title">
                                {{
                                    appParams.staticTranslations[
                                        "other_products_water_fountains.options_title_right"
                                    ]
                                }}
                            </h2>
                            <div class="m-0 text-white">
                                <ul
                                    style="
                                        font-size: 1.25rem;
                                        margin: 0;
                                        padding-left: 1.35rem;
                                    "
                                >
                                    <li>
                                        {{
                                            appParams.staticTranslations[
                                                "other_products_water_fountains.options_text_right_cleanvar_01"
                                            ]
                                        }}
                                    </li>
                                    <li>
                                        {{
                                            appParams.staticTranslations[
                                                "other_products_water_fountains.options_text_right_cleanvar_02"
                                            ]
                                        }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section
            v-if="$route.params.productAlias == 'built-in-tunnels'"
            id="itb-other-products-built-in-tunnels-variations"
        >
            <h2 class="text-center mt-4 mb-5">
                {{
                    appParams.staticTranslations[
                        "other_products_built_in_tunnels.variations_title"
                    ]
                }}
            </h2>
            <div class="container">
                <div class="row">
                    <div
                        class="col-12 text-center"
                        v-lazy-container="{ selector: '.itb-lazy' }"
                    >
                        <img
                            :data-src="'/images/articles/other-products-built-in-tunnels-variations-1.webp'"
                            alt="Variations 1"
                            class="itb-lazy"
                        />
                    </div>
                    <div
                        class="col-12 text-center mt-3"
                        v-lazy-container="{ selector: '.itb-lazy' }"
                    >
                        <img
                            :data-src="'/images/articles/other-products-built-in-tunnels-variations-2.webp'"
                            alt="Variations 2"
                            class="itb-lazy"
                        />
                    </div>
                </div>
            </div>
        </section>

        <hero-cards
            :cards="heroCards2"
            v-if="$route.params.productAlias == 'water-fountains'"
        ></hero-cards>

        <section
            v-if="gallery"
            id="itb-other-products-gallery"
            :class="{
                'mb-3': $route.params.productAlias == 'built-in-tunnels',
            }"
        >
            <div class="container">
                <div class="row">
                    <div
                        v-for="(img, index) in gallery"
                        :key="index"
                        :class="
                            img.col_classess
                                ? img.col_classess
                                : 'col-12 col-sm-6 col-md-4 mb-4'
                        "
                        v-lazy-container="{ selector: '.itb-lazy' }"
                    >
                        <img
                            :data-src="'/images/articles/' + img.path"
                            :alt="img.title"
                            class="itb-lazy"
                            style="width: 100%"
                        />
                    </div>
                </div>
            </div>
        </section>

        <hr
            class="itb-furniture-divider"
            v-if="$route.params.productAlias == 'epdm-furniture'"
        />

        <hero-cards
            :cards="heroCards2"
            class="mt-0 mt-lg-2"
            v-if="
                $route.params.productAlias == 'promotional-graphics' ||
                $route.params.productAlias == 'epdm-panelling'
            "
        ></hero-cards>

        <hero-cards
            :cards="heroCards2"
            v-if="$route.params.productAlias == 'epdm-furniture'"
            class="mt-0 pb-0"
        ></hero-cards>

        <section v-if="gallery2" id="itb-other-products-gallery-2">
            <div class="container">
                <div class="row">
                    <div
                        v-for="(img, index) in gallery2"
                        :key="index"
                        :class="
                            img.col_classess
                                ? img.col_classess
                                : 'col-12 col-sm-6 col-md-4 mb-4'
                        "
                        v-lazy-container="{ selector: '.itb-lazy' }"
                    >
                        <img
                            :data-src="'/images/articles/' + img.path"
                            :alt="img.title"
                            class="itb-lazy"
                            style="width: 100%"
                        />
                    </div>
                </div>
            </div>
        </section>

        <hr
            class="itb-furniture-divider"
            v-if="$route.params.productAlias == 'epdm-furniture'"
        />

        <hero-cards
            :cards="heroCards3"
            v-if="$route.params.productAlias == 'epdm-furniture'"
            class="mt-0 pb-0"
        ></hero-cards>

        <section v-if="gallery3" id="itb-other-products-gallery-3">
            <div class="container">
                <div class="row">
                    <div
                        v-for="(img, index) in gallery3"
                        :key="index"
                        :class="
                            img.col_classess
                                ? img.col_classess
                                : 'col-12 col-sm-6 col-md-4 mb-4'
                        "
                        v-lazy-container="{ selector: '.itb-lazy' }"
                    >
                        <img
                            :data-src="'/images/articles/' + img.path"
                            :alt="img.title"
                            class="itb-lazy"
                            style="width: 100%"
                        />
                    </div>
                </div>
            </div>
        </section>

        <hr
            class="itb-furniture-divider"
            v-if="$route.params.productAlias == 'epdm-furniture'"
        />

        <hero-cards
            :cards="heroCards4"
            v-if="$route.params.productAlias == 'epdm-furniture'"
            class="mt-0 pb-0"
        ></hero-cards>

        <section v-if="gallery4" id="itb-other-products-gallery-4">
            <div class="container">
                <div class="row">
                    <div
                        v-for="(img, index) in gallery4"
                        :key="index"
                        :class="
                            img.col_classess
                                ? img.col_classess
                                : 'col-12 col-sm-6 col-md-4 mb-4'
                        "
                        v-lazy-container="{ selector: '.itb-lazy' }"
                    >
                        <img
                            :data-src="'/images/articles/' + img.path"
                            :alt="img.title"
                            class="itb-lazy"
                            style="width: 100%"
                        />
                    </div>
                </div>
            </div>
        </section>

        <hr
            class="itb-furniture-divider"
            v-if="$route.params.productAlias == 'epdm-furniture'"
        />

        <hero-cards
            :cards="heroCards5"
            v-if="$route.params.productAlias == 'epdm-furniture'"
            class="mt-0 pb-0"
        ></hero-cards>

        <section v-if="gallery5" id="itb-other-products-gallery-5">
            <div class="container">
                <div class="row">
                    <div
                        v-for="(img, index) in gallery5"
                        :key="index"
                        :class="
                            img.col_classess
                                ? img.col_classess
                                : 'col-12 col-sm-6 col-md-4 mb-4'
                        "
                        v-lazy-container="{ selector: '.itb-lazy' }"
                    >
                        <img
                            :data-src="'/images/articles/' + img.path"
                            :alt="img.title"
                            class="itb-lazy"
                            style="width: 100%"
                        />
                    </div>
                </div>
            </div>
        </section>

        <section
            v-if="$route.params.productAlias == '3d-playhouses'"
            id="itb-other-products-3d-playhouses-options"
        >
            <div class="container">
                <div class="row">
                    <div class="col-12 col-md-6 itb-left-box">
                        <div
                            class="itb-top-image"
                            v-lazy:background-image="
                                '/images/articles/other-products-3d-playhouses-box-1.webp'
                            "
                        ></div>
                        <div class="itb-middle-text itb-bg-blue">
                            <p class="m-0" style="font-size: 1.25rem">
                                {{
                                    appParams.staticTranslations[
                                        "other_products_3d_playhouses.options_text_left_cleanvar_01"
                                    ]
                                }}
                            </p>
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div
                            class="itb-top-image"
                            v-lazy:background-image="
                                '/images/articles/other-products-3d-playhouses-box-2.webp'
                            "
                        ></div>
                        <div class="itb-middle-text itb-bg-orange">
                            <p class="mb-0" style="font-size: 1.25rem">
                                {{
                                    appParams.staticTranslations[
                                        "other_products_3d_playhouses.options_text_right_cleanvar_01"
                                    ]
                                }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <OtherProductsRealizations
            v-if="realizations && realizations.length > 0"
            :realizations="realizations"
            :categoryAlias="$route.params.productAlias"
            :inspirationTitle="inspirationTitle"
        />

        <section
            class="itb-catalog-intro itb-hero-cards"
            v-if="$route.params.productAlias == 'water-fountains'"
        >
            <div class="container">
                <div class="itb-hero-card row d-flex align-content-center mx-0">
                    <div
                        v-if="isResponsive"
                        class="itb-hero-responsive-image"
                        v-lazy:background-image="
                            '/images/articles/catalog-intro-water-fountains.webp'
                        "
                    ></div>
                    <div class="itb-fake-background">
                        <div
                            class="itb-lazy-loading-bg"
                            v-lazy:background-image="
                                !isResponsive
                                    ? '/images/articles/catalog-intro-water-fountains.webp'
                                    : '/images/articles/blank-bg.webp'
                            "
                        ></div>
                    </div>

                    <div class="col-12 col-md-6 col-lg-4 mb-3 mb-md-0">
                        <div
                            class="itb-card itb-bg-blue h-100 d-flex align-items-center"
                        >
                            <div>
                                <h2>
                                    {{
                                        appParams.staticTranslations[
                                            "other_products_water_fountains.catalog_intro_title"
                                        ]
                                    }}
                                </h2>
                                <router-link
                                    :to="catalogueLink"
                                    class="btn btn-secondary itb-btn-icon"
                                >
                                    {{
                                        appParams.staticTranslations[
                                            "graphics.show_all_products"
                                        ]
                                    }}
                                    <img
                                        src="/images/icons/4soft_icon_angle-right.svg"
                                        :alt="
                                            appParams.staticTranslations[
                                                'general.button'
                                            ] +
                                            ' ' +
                                            appParams.staticTranslations[
                                                'main_category.show_all_realizations'
                                            ]
                                        "
                                        class="itb-icon itb-angle-right-icon"
                                    />
                                </router-link>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-md-6 col-lg-8">
                        <div class="row h-100">
                            <div
                                class="col-12 col-md-6 col-lg-4 mb-3 mb-md-0"
                                v-for="graphic in graphics"
                                :key="graphic.id"
                            >
                                <div
                                    class="card h-100 text-center"
                                    style="overflow: hidden"
                                >
                                    <div class="card-body d-flex p-0">
                                        <div class="align-self-end w-100">
                                            <img
                                                :src="
                                                    graphic.image
                                                        ? '/uploads/' +
                                                          graphic.image
                                                        : null
                                                "
                                                :alt="graphic.name"
                                            />
                                            <h3 class="itb-blue">
                                                {{ graphic.name }}
                                            </h3>

                                            <p>
                                                {{ graphic.description }}
                                            </p>
                                            <router-link
                                                :to="{
                                                    name: 'graphicDetail',
                                                    params: {
                                                        categoryAlias: 'others',
                                                        subcategoryAlias:
                                                            graphic.subcategoryAlias,
                                                        subcategory2Alias:
                                                            graphic.subcategory2Alias,
                                                        graphicAlias:
                                                            graphic.id +
                                                            '-' +
                                                            graphic.alias,
                                                    },
                                                }"
                                                class="btn btn-primary"
                                            >
                                                {{
                                                    appParams
                                                        .staticTranslations[
                                                        "graphics.detail"
                                                    ]
                                                }}
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section
            class="itb-catalog-intro itb-hero-cards"
            v-if="$route.params.productAlias == 'mini-tunnels'"
        >
            <div class="container">
                <div class="itb-hero-card row d-flex align-content-center mx-0">
                    <div
                        v-if="isResponsive"
                        class="itb-hero-responsive-image"
                        v-lazy:background-image="
                            '/images/articles/catalog-intro-mini-tunnels.webp'
                        "
                    ></div>
                    <div class="itb-fake-background">
                        <div
                            class="itb-lazy-loading-bg"
                            v-lazy:background-image="
                                !isResponsive
                                    ? '/images/articles/catalog-intro-mini-tunnels.webp'
                                    : '/images/articles/blank-bg.webp'
                            "
                        ></div>
                    </div>

                    <div class="col-12 col-md-6 col-lg-4 mb-3 mb-md-0">
                        <div
                            class="itb-card itb-bg-blue h-100 d-flex align-items-center"
                        >
                            <div>
                                <h2>
                                    {{
                                        appParams.staticTranslations[
                                            "other_products_mini_tunnels.catalog_intro_title"
                                        ]
                                    }}
                                </h2>
                                <router-link
                                    :to="catalogueLink"
                                    class="btn btn-secondary itb-btn-icon"
                                >
                                    {{
                                        appParams.staticTranslations[
                                            "graphics.show_all_products"
                                        ]
                                    }}
                                    <img
                                        src="/images/icons/4soft_icon_angle-right.svg"
                                        :alt="
                                            appParams.staticTranslations[
                                                'general.button'
                                            ] +
                                            ' ' +
                                            appParams.staticTranslations[
                                                'main_category.show_all_realizations'
                                            ]
                                        "
                                        class="itb-icon itb-angle-right-icon"
                                    />
                                </router-link>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-md-6 col-lg-8">
                        <div class="row h-100">
                            <div
                                class="col-12 col-md-6 col-lg-4 mb-3 mb-md-0"
                                v-for="graphic in graphics"
                                :key="graphic.id"
                            >
                                <div
                                    class="card h-100 text-center"
                                    style="overflow: hidden"
                                >
                                    <div class="card-body d-flex p-0">
                                        <div class="align-self-end w-100">
                                            <img
                                                :src="
                                                    graphic.image
                                                        ? '/uploads/' +
                                                          graphic.image
                                                        : null
                                                "
                                                :alt="graphic.name"
                                            />
                                            <h3 class="itb-blue">
                                                {{ graphic.name }}
                                            </h3>

                                            <p>
                                                {{ graphic.description }}
                                            </p>
                                            <router-link
                                                :to="{
                                                    name: 'graphicDetail',
                                                    params: {
                                                        categoryAlias: 'others',
                                                        subcategoryAlias:
                                                            graphic.subcategoryAlias,
                                                        subcategory2Alias:
                                                            graphic.subcategory2Alias,
                                                        graphicAlias:
                                                            graphic.id +
                                                            '-' +
                                                            graphic.alias,
                                                    },
                                                }"
                                                class="btn btn-primary"
                                            >
                                                {{
                                                    appParams
                                                        .staticTranslations[
                                                        "graphics.detail"
                                                    ]
                                                }}
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <hero-cards
            :carhero-cads="heroCards2"
            v-if="$route.params.productAlias == 'built-in-tunnels'"
            class="mt-0"
        ></hero-cards>
        <section
            class="itb-catalog-intro itb-hero-cards"
            v-if="$route.params.productAlias == 'built-in-tunnels'"
        >
            <div class="container">
                <div class="itb-hero-card row d-flex align-content-center mx-0">
                    <div
                        v-if="isResponsive"
                        class="itb-hero-responsive-image"
                        v-lazy:background-image="
                            '/images/articles/catalog-intro-built-in-tunnels.webp'
                        "
                    ></div>
                    <div class="itb-fake-background">
                        <div
                            class="itb-lazy-loading-bg"
                            v-lazy:background-image="
                                !isResponsive
                                    ? '/images/articles/catalog-intro-built-in-tunnels.webp'
                                    : '/images/articles/blank-bg.webp'
                            "
                        ></div>
                    </div>

                    <div class="col-12 col-md-6 col-lg-4 mb-3 mb-md-0">
                        <div
                            class="itb-card itb-bg-blue h-100 d-flex align-items-center"
                        >
                            <div>
                                <h2>
                                    {{
                                        appParams.staticTranslations[
                                            "other_products_built_in_tunnels.catalog_intro_title"
                                        ]
                                    }}
                                </h2>
                                <router-link
                                    :to="catalogueLink"
                                    class="btn btn-secondary itb-btn-icon"
                                >
                                    {{
                                        appParams.staticTranslations[
                                            "graphics.show_all_products"
                                        ]
                                    }}
                                    <img
                                        src="/images/icons/4soft_icon_angle-right.svg"
                                        :alt="
                                            appParams.staticTranslations[
                                                'general.button'
                                            ] +
                                            ' ' +
                                            appParams.staticTranslations[
                                                'main_category.show_all_realizations'
                                            ]
                                        "
                                        class="itb-icon itb-angle-right-icon"
                                    />
                                </router-link>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-md-6 col-lg-8">
                        <div class="row h-100">
                            <div
                                class="col-12 col-md-6 col-lg-4 mb-3 mb-md-0"
                                v-for="graphic in graphics"
                                :key="graphic.id"
                            >
                                <div
                                    class="card h-100 text-center"
                                    style="overflow: hidden"
                                >
                                    <div class="card-body d-flex p-0">
                                        <div class="align-self-end w-100">
                                            <img
                                                :src="
                                                    graphic.image
                                                        ? '/uploads/' +
                                                          graphic.image
                                                        : null
                                                "
                                                :alt="graphic.name"
                                            />
                                            <h3 class="itb-blue">
                                                {{ graphic.name }}
                                            </h3>

                                            <p>
                                                {{ graphic.description }}
                                            </p>
                                            <router-link
                                                :to="{
                                                    name: 'graphicDetail',
                                                    params: {
                                                        categoryAlias: 'others',
                                                        subcategoryAlias:
                                                            graphic.subcategoryAlias,
                                                        subcategory2Alias:
                                                            graphic.subcategory2Alias,
                                                        graphicAlias:
                                                            graphic.id +
                                                            '-' +
                                                            graphic.alias,
                                                    },
                                                }"
                                                class="btn btn-primary"
                                            >
                                                {{
                                                    appParams
                                                        .staticTranslations[
                                                        "graphics.detail"
                                                    ]
                                                }}
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section
            v-if="$route.params.productAlias == 'built-in-tunnels'"
            id="itb-other-products-built-in-tunnels-samples"
        >
            <h2 class="text-center">
                {{
                    appParams.staticTranslations[
                        "other_products_built_in_tunnels.samples_title"
                    ]
                }}
            </h2>
            <div class="container">
                <div class="row">
                    <div
                        class="col-12 text-center"
                        v-lazy-container="{ selector: '.itb-lazy' }"
                    >
                        <img
                            :data-src="'/images/articles/other-products-built-in-tunnels-samples-1.webp'"
                            alt="Samples 1"
                            class="itb-lazy"
                        />
                    </div>
                    <div
                        class="col-12 text-center"
                        v-lazy-container="{ selector: '.itb-lazy' }"
                    >
                        <img
                            :data-src="'/images/articles/other-products-built-in-tunnels-samples-2.webp'"
                            alt="Samples 2"
                            class="itb-lazy"
                        />
                    </div>
                </div>
            </div>
        </section>
        <section
            class="itb-catalog-intro itb-hero-cards"
            v-if="$route.params.productAlias == '3d-playhouses'"
        >
            <div class="container">
                <div class="itb-hero-card row d-flex align-content-center mx-0">
                    <div
                        v-if="isResponsive"
                        class="itb-hero-responsive-image"
                        v-lazy:background-image="
                            '/images/articles/catalog-intro-3d-playhouses.webp'
                        "
                    ></div>
                    <div class="itb-fake-background">
                        <div
                            class="itb-lazy-loading-bg"
                            v-lazy:background-image="
                                !isResponsive
                                    ? '/images/articles/catalog-intro-3d-playhouses.webp'
                                    : '/images/articles/blank-bg.webp'
                            "
                        ></div>
                    </div>

                    <div class="col-12 col-md-6 col-lg-4 mb-3 mb-md-0">
                        <div
                            class="itb-card itb-bg-blue h-100 d-flex align-items-center"
                        >
                            <div>
                                <h2>
                                    {{
                                        appParams.staticTranslations[
                                            "other_products_3d_playhouses.catalog_intro_title"
                                        ]
                                    }}
                                </h2>
                                <router-link
                                    :to="catalogueLink"
                                    class="btn btn-secondary itb-btn-icon"
                                >
                                    {{
                                        appParams.staticTranslations[
                                            "graphics.show_all_products"
                                        ]
                                    }}
                                    <img
                                        src="/images/icons/4soft_icon_angle-right.svg"
                                        :alt="
                                            appParams.staticTranslations[
                                                'general.button'
                                            ] +
                                            ' ' +
                                            appParams.staticTranslations[
                                                'main_category.show_all_realizations'
                                            ]
                                        "
                                        class="itb-icon itb-angle-right-icon"
                                    />
                                </router-link>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-md-6 col-lg-8">
                        <div class="row h-100">
                            <div
                                class="col-12 col-md-6 col-lg-4 mb-3 mb-md-0"
                                v-for="graphic in graphics"
                                :key="graphic.id"
                            >
                                <div
                                    class="card h-100 text-center"
                                    style="overflow: hidden"
                                >
                                    <div class="card-body d-flex p-0">
                                        <div class="align-self-end w-100">
                                            <img
                                                :src="
                                                    graphic.image
                                                        ? '/uploads/' +
                                                          graphic.image
                                                        : null
                                                "
                                                :alt="graphic.name"
                                            />
                                            <h3 class="itb-blue">
                                                {{ graphic.name }}
                                            </h3>

                                            <p>
                                                {{ graphic.description }}
                                            </p>
                                            <router-link
                                                :to="{
                                                    name: 'graphicDetail',
                                                    params: {
                                                        categoryAlias: 'others',
                                                        subcategoryAlias:
                                                            graphic.subcategoryAlias,
                                                        subcategory2Alias:
                                                            graphic.subcategory2Alias,
                                                        graphicAlias:
                                                            graphic.id +
                                                            '-' +
                                                            graphic.alias,
                                                    },
                                                }"
                                                class="btn btn-primary"
                                            >
                                                {{
                                                    appParams
                                                        .staticTranslations[
                                                        "graphics.detail"
                                                    ]
                                                }}
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import OtherProductsRealizations from "../components/OtherProductsRealizations";

export default {
    data() {
        return {
            heroCards: [],
            heroCards2: [],
            heroCards3: [],
            heroCards4: [],
            heroCards5: [],
            gallery: [],
            gallery2: [],
            gallery3: [],
            gallery4: [],
            gallery5: [],
            pageParams: [],
            graphics: [],
            catalogueLink: "",
            realizations: [],
            isResponsive: false,
        };
    },

    created() {
        this.onResize();
        window.addEventListener("resize", this.onResize);
    },

    beforeDestroy() {
        window.removeEventListener("resize", this.onResize);
    },

    mounted() {
        axios
            .post(
                `/getOtherProductDetailPage/${this.$route.params.productAlias}`,
                {
                    client_id: this.profile.id,
                    is_logged_in: this.isLoggedIn,
                }
            )
            .then((response) => {
                this.heroCards = response.data.heroCards;
                this.graphics = response.data.graphics;
                this.graphics.forEach((item) => {
                    item.description = item.description.slice(0, 100);
                });
                this.catalogueLink = response.data.catalogueLink;

                if (response.data.heroCards2) {
                    this.heroCards2 = response.data.heroCards2;
                }

                if (response.data.heroCards3) {
                    this.heroCards3 = response.data.heroCards3;
                }

                if (response.data.heroCards4) {
                    this.heroCards4 = response.data.heroCards4;
                }

                if (response.data.heroCards5) {
                    this.heroCards5 = response.data.heroCards5;
                }

                if (response.data.gallery) {
                    this.gallery = response.data.gallery;
                }

                if (response.data.gallery2) {
                    this.gallery2 = response.data.gallery2;
                }

                if (response.data.gallery3) {
                    this.gallery3 = response.data.gallery3;
                }

                if (response.data.gallery4) {
                    this.gallery4 = response.data.gallery4;
                }

                if (response.data.gallery5) {
                    this.gallery5 = response.data.gallery5;
                }

                this.pageParams = response.data.params;

                this.setPageParams(this.pageParams);
            })
            .catch((error) => {
                console.log(error);
            });

        this.getRealizations();
    },
    components: {
        OtherProductsRealizations,
    },

    computed: {
        ...mapGetters({
            appParams: "getAppParams",
            isLoggedIn: "getClientLogged",
            profile: "getClientProfile",
        }),

        inspirationTitle: function () {
            return this.appParams.staticTranslations[
                "constants.main_category." +
                    this.$route.params.productAlias.replace(/-/g, "_") +
                    ".name"
            ];
        },
    },

    methods: {
        ...mapActions(["setPageParams", "setFormParams"]),

        getRealizations() {
            if (this.$route.params.productAlias != "epdm-panelling") {
                axios
                    .get(
                        `/getOtherProductsRealizations/${this.$route.params.productAlias}`
                    )
                    .then((response) => {
                        this.realizations = response.data;
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        },

        onResize() {
            if (window.innerWidth < 992) {
                this.isResponsive = true;
            } else {
                this.isResponsive = false;
            }
        },

        scrollToElement(elementId) {
            var element = document.getElementById(elementId);

            if (element) {
                var navbar = document.getElementById("itb-navbar");
                var elementPosition = element.offsetTop;
                var offsetPosition = elementPosition - navbar.offsetHeight;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth",
                });
            }
        },
    },
};
</script>
